class CartReservationTimer extends HTMLElement {
  constructor() {
    super();
    this.timeEl = this.querySelector('[data-ref="time"]');
    this.durationMinutes = parseFloat(this.dataset.durationMinutes) || 15;
    this.signature = this.dataset.cartSignature;
    this.clearOnExpire = this.dataset.clearCartOnExpire === 'true';
    this.sectionId = this.dataset.sectionId;
    this.storageKey = `cart-reservation-timer:${this.signature}`;
  }

  connectedCallback() {
    if (this.dataset.cartEmpty === 'true') return;

    this.startTime = this.getStartTime();
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);

    this.visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        this.tick();
      }
    };
    document.addEventListener('visibilitychange', this.visibilityHandler);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler);
    }
  }

  getStartTime() {
    const stored = sessionStorage.getItem(this.storageKey);
    if (stored) return parseInt(stored, 10);
    const now = Date.now();
    sessionStorage.setItem(this.storageKey, now.toString());
    return now;
  }

  tick() {
    const remainingMs = (this.durationMinutes * 60 * 1000) - (Date.now() - this.startTime);
    if (remainingMs <= 0) return this.expire();
    const totalSeconds = Math.floor(remainingMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    this.timeEl.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  async expire() {
    clearInterval(this.interval);
    this.timeEl.textContent = '0:00';
    if (!this.clearOnExpire) return;

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      sessionStorage.removeItem(this.storageKey);

      document.querySelectorAll('[data-ref="cart-count"]').forEach((el) => {
        el.textContent = '0';
      });
    } catch (e) {
      console.error('Cart reservation timer: expiration failed', e);
    }
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}